<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pMultiselect'" :item="itemTipoDistinta" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
              <v-col><v-text-field :label="documento && documento.codice ? 'Numero distinta' : 'Numero distinta (auto)'" hide-details outlined dense disabled :value="codice"></v-text-field></v-col>
              <v-col><component :is="'pData'" :item="itemData" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
<!--             <v-row dense>
              <v-col lg="6"><component :is="'pMultiselect'" :item="itemMagazzino" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>   -->          
          </v-card>  
        </v-col>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pTesto'" :item="itemInfoDistinta" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemRiferimento" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
<!--             <v-row dense>
              <v-col>
                <component :is="'pData'" :item="itemDataScadenza" :appoggio="documento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/>
              </v-col>
              <v-col>
                <v-btn @click="addMesiDataScadenza(6)" title="Data odierna più 6 mesi">+6 mesi</v-btn><v-btn class="ml-5" title="Data odierna più 1 anno" @click="addMesiDataScadenza(12)">+1 anno</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row> -->
          </v-card>   
        </v-col>   
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import moment from 'moment'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import pMultiselect from './elementi/multiselect'
import pData from './elementi/data'
import pTesto from './elementi/testo'

export default {
  components: {
    pMultiselect,
    pData,
    pTesto
/*     pClifor,
    pTesto */
  },
  props: {
    documento: Object,
    trigger: Number,
    filtraTipiLotto: Array,
    mostraParcheggio: Boolean
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
  },
  watch: {
    async documento(value) {
      // this.documento = await documenti.getLotto(value)
      // this.documento = value
    },
    trigger() {

    }
  },
  computed: {
    lottoItems() {
      if (!this.documento || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        // items.push({value: dot.pick(item.valueField, this.documento, ''), ...item})
        items.push({value: _.get(this, `documento.${item.valueField}`, ''), ...item})
      }
      // console.log(items)
      return items
    },
    codice() {
      return this.trigger && this.documento && this.documento.codice
    },
    cliente() {
      return _.get(this.documento, 'anagrafica.cliente')
    },
    pagamentoVisibile() {
      return this.documento && this.documento.appoggio && this.documento.appoggio.pagamentoVisibile
    },
    clienteVisibile() {
      return this.documento && this.documento.appoggio && this.documento.appoggio.clienteVisibile
    },
    fornitoreVisibile() {
      return this.documento && this.documento.appoggio && this.documento.appoggio.fornitoreVisibile
    },
    spedizioneVisibile() {
      return this.documento && this.documento.appoggio && this.documento.appoggio.spedizioneVisibile
    },
    magazzinoVisibile() {
      return this.trigger && this.documento && this.documento.tipoLotto && ['fatturaImmediata', 'ddt'].includes(this.documento.tipoLotto.codice)
    },
    sede() {
      const destinazione = _.get(this.documento, 'spedizione.destinazione', null)
      if (destinazione) {
        return destinazione
      } else {
        return this.cliente.recapiti.length > 0 ? this.cliente.recapiti[0] : {} 
      }
    },
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza distinta'
      } else {
        return this.documento && this.documento._id ? 'Modifica distinta' : 'Nuova distinta'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.documento, 'tipoLotto.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['documenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    },
    readOnlySeModifica() {
      return _.get(this, 'documento.codice', '') !== ''
    },
    itemTipoDistinta() {
      return {
        "model": "tipoNumerazioneDistinta.codice",
        "subModel": "codice",
        "valueField": "tipoNumerazioneDistinta.codice",
        "type": "Multiselect",
        "label": "Tipo numerazione",
       //  "source": "documenti_parametri.tipiLotto",
        "source": "lotti.tipiNumerazioneDistinta",
        "required": true,
        "addForbidden": true,
        value: _.get(this.documento, 'tipoNumerazioneDistinta.codice', 'automatico')
      }
    },
    itemData() {
      return  {
        "model": "data",
        "valueField": "data",
        "label": "Data",
        "type": "Data",
        "required": true,
        value: _.get(this.documento, 'data', '')
      }
    },
    itemDataScadenza() {
      return  {
        "model": "dataScadenza",
        "valueField": "dataScadenza",
        "label": "Data scadenza",
        "type": "Data",
        "required": true,
        value: this.updateTrigger && _.get(this.documento, 'dataScadenza', new Date())
      }
    },    
    itemMagazzino() {
      return {
        "model": "magazzino",
        "subModel": "codice",
        "valueField": "magazzino",
        "type": "Multiselect",
        "label": "Magazzino movimento",
        "source": "	magazzino_magazzini.magazzini",
        "required": true,
        "addForbidden": true,
        value: _.get(this.documento, 'magazzino', '')
      }
    },
    itemInfoDistinta() {
      return {
        "model": "custom.info",
        "valueField": "custom.info",
        "label": "Info Distinta",
        "type": "Testo",
        "readonly": false,
        "update": this.updateTrigger,
        value: _.get(this.documento, 'custom.info', '')
      }
    },
    itemRiferimento() {
      return {
        "model": "custom.riferimento",
        "valueField": "custom.riferimento",
        "label": "Riferimento",
        "type": "Testo",
        "readonly": false,
        "update": this.updateTrigger,
        value: _.get(this.documento, 'custom.riferimento', '')
      }
    }
  },
  methods: {
    addMesiDataScadenza(mesi) {
      this.documento.dataScadenza = moment().add(mesi, 'months').add(-1, 'days').toDate()
      this.updateTrigger++
    },
    items(idx) {
      const ret = this.lottoItems && this.lottoItems.length >= idx ? this.lottoItems[idx] : {}
      console.log('ret', ret)
      return ret
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value ? value[subModel] : ''
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.documento, tgt)
      await this.aggiornaCorrelati(data)
      this.$emit('aggiornaDocumento', this.documento)
      // this.$store.commit('documenti/SET_DOCUMENTO', this.documento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      // this.documento.appoggio = this.documento.appoggio || {}
      switch (data.model) {
         case 'tipoLotto.codice':
          this.documento.appoggio.tipoLotto = data.value
          this.documento.appoggio.clienteVisibile = _.get(data.value, 'visualizzaCliente', false)
          this.documento.appoggio.fornitoreVisibile = _.get(data.value, 'visualizzaFornitore', false)
          this.documento.appoggio.spedizioneVisibile = _.get(data.value, 'infoSpedizione', false)
          this.documento.appoggio.pagamentoVisibile = _.get(data.value, 'infoPagamento', false)
          this.documento.tipoLotto = data.value
          // this.documento.tipoLottoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.documento.appoggio.clifor = clifor
          _.set(this.documento,'appoggio.clifor', clifor)
          _.set(this.documento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
          _.set(this.documento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
          const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
          _.set(this.documento, 'spedizione.destinazione', sede)
          _.set(this.documento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
          _.set(this.documento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))         
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.documento, 'spedizione.destinazione', data.value)
          break;
        case 'dataScadenza':
          await this.$nextTick()
          this.updateTrigger++
          break
        default:
          this.updateTrigger++
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documenti/CLEAR_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('documenti/SET_DOCUMENTO', this.documento)
        this.$store.commit('documenti/SET_DOCUMENTO_SAVED')
      }
    }
  }
}
</script>
